const potholeDataTable = (() => {
    let widget = null;
    let tab1 = null;
    let tab2 = null;
    let tab1Button = null;
    let tab2Button = null;
    let dataConfig = null;
    let template = null;
    let compTemplate = null;
    let reportsTableBody = null;
    let compensationTableBody = null;
    let countrySelect = null;
    let parsedConfig = null;
    let countriesList = [];
    const humanize = (s) => String(s).replace(/-/g, ' ').split(' ').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');

    const init = async () => {
        cacheElements();
        bindTabs();
        countriesList = [];
        await loadData();
        bindCountrySelect();
    };

    const cacheElements = () => {
        widget = document.getElementById('potholes__DataTable');
        if (widget) {
            tab1 = widget.querySelector('#potholes__Tab1');
            tab2 = widget.querySelector('#potholes__Tab2');
            tab1Button = widget.querySelector('[data-tab="tab1"]');
            tab2Button = widget.querySelector('[data-tab="tab2"]');
            dataConfig = widget.getAttribute('data-config');
            reportsTableBody = widget.querySelector('#potholes__DataTable--reports');
            compensationTableBody = widget.querySelector('#potholes__DataTable--compensation');
            countrySelect = widget.querySelector('#potholes__DataTable--Country');
        }
        template = document.getElementById('reports-row-template');
        compTemplate = document.getElementById('compensation-row-template');
    };

    const bindTabs = () => {
        if (tab1Button) tab1Button.addEventListener('click', () => showTab(1));
        if (tab2Button) tab2Button.addEventListener('click', () => showTab(2));
    };

    const loadData = async () => {
        if (!dataConfig) {
            console.warn('Missing data-config attribute on #potholes__DataTable.');
            return;
        }

        try {
            const configAttr = JSON.parse(dataConfig);
            const dataUrl = configAttr && configAttr.potholesData ? configAttr.potholesData : dataConfig;

            if (!dataUrl || typeof dataUrl !== 'string') {
                throw new Error('Missing or invalid potholesData URL in data-config.');
            }

            // fetch the data from the URL in data-config
            const response = await fetch(dataUrl);
            if (!response.ok) {
                throw new Error(`Failed to fetch potholes data (${response.status} ${response.statusText}) from ${dataUrl}`);
            }

            const config = await response.json();
            if (!config || typeof config !== 'object') {
                throw new Error('Potholes data response is not a JSON object.');
            }

            // derive countries list
            if (Array.isArray(config?.countries)) {
                countriesList = config.countries;
            } else if (config && typeof config === 'object') {
                // if we don't have a dedicated countries array, attempt to derive list from top-level keys (excluding known non-country keys);
                const topKeys = Object.keys(config).filter(k => k !== 'reports' && k !== 'compensation' && k !== 'countries' && config[k] && typeof config[k] === 'object' && !Array.isArray(config[k]));
                if (topKeys.length) {
                    countriesList = topKeys.map(k => {
                        const obj = config[k] || {};
                        return { code: obj.code || k, name: obj.name || humanize(k) };
                    });
                }
            }

            // persist parsed config
            parsedConfig = config;

            if (!countriesList.length) {
                console.warn('Potholes data loaded but no countries were found in the response.');
            }

        } catch (err) {
            const reason = err instanceof Error ? err.message : 'Unknown error.';
            console.error('Potholes data table failed to load:', reason, err);
        }
    };

    const bindCountrySelect = () => {
        if (!countrySelect) {
            console.warn('Country select element not found: #potholes__DataTable--Country');
            return;
        }

        if (countriesList && countriesList.length) {
            countriesList.forEach(country => {
                const option = document.createElement('option');
                option.value = country.code;
                option.textContent = country.name;
                countrySelect.appendChild(option);
            });
            countrySelect.addEventListener('change', (e) => renderCountryData(e.target.value));
            // ensure a known selection before initial render
            if (countrySelect.options.length) {
                countrySelect.selectedIndex = 0;
                renderCountryData(countrySelect.value);
            }
        }
    };

    const showTab = (tabNumber) => {
        if (!tab1 || !tab2) return;
        if (tabNumber === 1) {
            tab1Button.classList.add('tabbed-nav__tab--active');
            tab2Button.classList.remove('tabbed-nav__tab--active');
            tab1.classList.remove('display-none');
            tab2.classList.add('display-none');
        } else {
            tab1Button.classList.remove('tabbed-nav__tab--active');
            tab2Button.classList.add('tabbed-nav__tab--active');
            tab1.classList.add('display-none');
            tab2.classList.remove('display-none');
        }
    };

    function renderCountryData(code) {
        if (!parsedConfig) return;
        if (reportsTableBody) reportsTableBody.innerHTML = '';
        if (compensationTableBody) compensationTableBody.innerHTML = '';

        // batch DOM updates into DocumentFragment for better performance
        const reportsFragment = document.createDocumentFragment();
        const compFragment = document.createDocumentFragment();

        // locate country object
        let countryObj = null;
        if (Array.isArray(parsedConfig?.countries)) {
            countryObj = parsedConfig.countries.find(c => c.code === code);
        }
        if (!countryObj && parsedConfig[code]) countryObj = parsedConfig[code];
        if (!countryObj) return;

        const renderReportRow = (container, countyName, reported, fixed) => {
            const newRow = template.content.cloneNode(true);
            const countyEl = newRow.querySelector('.county');
            const reportEl = newRow.querySelector('.report-count');
            const fixEl = newRow.querySelector('.fix-count');
            const countyDiv = countyEl.querySelector('div');
            const reportDiv = reportEl.querySelector('div');
            const fixDiv = fixEl.querySelector('div');
            if (countyDiv) countyDiv.textContent = countyName || '';
            if (reportDiv) reportDiv.textContent = reported != null ? reported : '';
            if (fixDiv) fixDiv.textContent = fixed != null ? fixed : '';
            if (container) container.appendChild(newRow);
        };

        // helper to create and append a compensation row (DRY)
        const renderCompRow = (container, label, total, success, paid) => {
            if (!container) return;
            if (compTemplate) {
                const newComp = compTemplate.content.cloneNode(true);
                const cCounty = newComp.querySelector('.comp-county');
                const cTotal = newComp.querySelector('.comp-totalClaims');
                const cSuccess = newComp.querySelector('.comp-totalClaimsSuccessful');
                const cPaid = newComp.querySelector('.comp-totalCompensationPaid');
                const cCountyDiv = cCounty.querySelector('div');
                const cTotalDiv = cTotal.querySelector('div');
                const cSuccessDiv = cSuccess.querySelector('div');
                const cPaidDiv = cPaid.querySelector('div');
                if (cCountyDiv) cCountyDiv.textContent = label;
                if (cTotalDiv) cTotalDiv.textContent = total;
                if (cSuccessDiv) cSuccessDiv.textContent = success;
                if (cPaidDiv) {
                    const paidNum = Number(paid);
                    const paidText = Number.isFinite(paidNum) ? paidNum.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : (paid != null ? String(paid) : '');
                    cPaidDiv.textContent = paidText;
                }
                container.appendChild(newComp);
            } else {
                const tr = document.createElement('tr');
                const td1 = document.createElement('td'); td1.textContent = label;
                const td2 = document.createElement('td'); td2.textContent = total;
                const td3 = document.createElement('td'); td3.textContent = success;
                const td4 = document.createElement('td');
                const paidNum = Number(paid);
                td4.textContent = Number.isFinite(paidNum) ? paidNum.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : (paid != null ? String(paid) : '');
                tr.appendChild(td1); tr.appendChild(td2); tr.appendChild(td3); tr.appendChild(td4);
                container.appendChild(tr);
            }
        };

        // summary country (detect if this country object contains top-level numeric fields)
        const isSummary = typeof countryObj.reports === 'number' || typeof countryObj.fixes === 'number' || typeof countryObj.totalClaims === 'number';
        if (isSummary) {
            // For the reports table use only `reports`/`reported` and `fixes`/`fixed` values — do not fall back to `totalClaims` here.
            const reportedVal = countryObj.reports ?? countryObj.reported ?? '';
            const fixedVal = countryObj.fixes ?? countryObj.fixed ?? '';
            renderReportRow(reportsFragment, countryObj.name || humanize(code), reportedVal, fixedVal);

            if (compensationTableBody) {
                const label = countryObj.name || humanize(code);
                const total = countryObj.totalClaims != null ? countryObj.totalClaims : (countryObj.reports ?? '');
                const success = countryObj.totalClaimsSuccessful != null ? countryObj.totalClaimsSuccessful : (countryObj.fixes ?? '');
                const paid = countryObj.totalCompensationPaid != null ? countryObj.totalCompensationPaid : '';
                renderCompRow(compFragment, label, total, success, paid);
            }

            if (reportsTableBody) reportsTableBody.appendChild(reportsFragment);
            if (compensationTableBody) compensationTableBody.appendChild(compFragment);
            return;
        }

        // iterate children
        Object.keys(countryObj).forEach(k => {
            if (k === 'reportLink' || k === 'claimLink') return;
            let val = countryObj[k];

            if (Array.isArray(val) && val.length > 0) {
                const first = val[0];
                if (first && typeof first === 'object') val = first;
            }

            if (val && typeof val === 'object') {
                // determine if this object has report/fix data at top level (vs needing to look deeper)
                // For report columns, only use `reports`/`reported` and `fixes`/`fixed` values — don't use `totalClaims` as a report count fallback.
                const reportedTop = (val.reports ?? val.reported) ?? '';
                const fixedTop = (val.fixes ?? val.fixed) ?? '';
                const hasTopNumeric = (typeof val.reports === 'number') || (typeof val.fixes === 'number') || reportedTop !== '' || fixedTop !== '';

                if (hasTopNumeric) {
                    // if we have report/fix data at this level, render it and use the key as label
                    const label = val.name || humanize(k);
                    renderReportRow(reportsFragment, label, reportedTop, fixedTop);

                    const hasComp = val.totalClaims != null || val.totalClaimsSuccessful != null || val.totalCompensationPaid != null || reportedTop !== '' || fixedTop !== '';
                    if (hasComp && compensationTableBody) {
                        // if we have compensation data at this level, render it; if not, attempt to use report/fix data as fallback for total/success
                        const total = val.totalClaims != null ? val.totalClaims : (reportedTop || '');
                        const success = val.totalClaimsSuccessful != null ? val.totalClaimsSuccessful : (fixedTop || '');
                        const paid = val.totalCompensationPaid != null ? val.totalCompensationPaid : '';
                        renderCompRow(compFragment, label, total, success, paid);
                    }
                } else {
                    const childKeys = Object.keys(val).filter(k2 => k2 !== 'reportLink' && k2 !== 'claimLink');
                    if (childKeys.length) {
                        // if we don't have report/fix data at this level, look one level deeper (some configs nest data an extra level for readability)
                        const firstKey = childKeys[0];
                        let child = val[firstKey];
                        if (Array.isArray(child) && child.length > 0) child = child[0];
                        if (child && typeof child === 'object') {
                            // if we find report/fix data at the child level, render using parent key as label (e.g. county name) and child data for values
                                const rep = (child.reports ?? child.reported) ?? '';
                                const fix = (child.fixes ?? child.fixed) ?? '';
                            const label = val.name || humanize(k);
                            renderReportRow(reportsFragment, label, rep, fix);

                            const hasChildComp = child.totalClaims != null || child.totalClaimsSuccessful != null || child.totalCompensationPaid != null || rep !== '' || fix !== '';
                            if (hasChildComp && compensationTableBody) {
                                const total = child.totalClaims != null ? child.totalClaims : (rep || '');
                                const success = child.totalClaimsSuccessful != null ? child.totalClaimsSuccessful : (fix || '');
                                const paid = child.totalCompensationPaid != null ? child.totalCompensationPaid : '';
                                renderCompRow(compFragment, label, total, success, paid);
                            }
                        }
                    }
                }
            } else {
                // if we don't have an object to look into, render the value directly
                renderReportRow(reportsFragment, humanize(k), val, '');
            }
        });

        // append batched fragments once
        if (reportsTableBody) reportsTableBody.appendChild(reportsFragment);
        if (compensationTableBody) compensationTableBody.appendChild(compFragment);
    }

    return {
        init: init,
    };
})();


document.addEventListener('DOMContentLoaded', () => {
   potholeDataTable.init();
});
